import { render, staticRenderFns } from "./CurrentGroupWidget.vue?vue&type=template&id=17504096&scoped=true&"
import script from "./CurrentGroupWidget.vue?vue&type=script&lang=js&"
export * from "./CurrentGroupWidget.vue?vue&type=script&lang=js&"
import style0 from "./CurrentGroupWidget.vue?vue&type=style&index=0&id=17504096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17504096",
  null
  
)

export default component.exports